import React from 'react';
import Entertain from '../Entertain';
type Props = {};

const EntertainContainer = (props: Props) => {
  return <Entertain />;
};

export default EntertainContainer;
